/* eslint-disable jsx-a11y/anchor-is-valid */
/*
 * File: UserDropdown.tsx
 * Project: receiving-rules
 * -----
 * Last Modified: 01 Oct 2020 8:02:25 pm
 * -----
 * Copyright (c) 2020 Elegant Software Solutions All rights reserved.
 */

import { ProfileOutlined } from '@ant-design/icons';
import { useAuth0 } from '@auth0/auth0-react';
import { Avatar, Dropdown, Menu, Spin } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useGetUserQuery } from 'redux/services/cookieMonster/cookieMonsterApi';
import { useAppSelector } from 'redux/store';
import { InlineStylesModel } from '../../models/InlineStylesModel';

export enum MenuKeys {
  logout = 'Log Out',
  about = 'About',
  profile = 'Profile'
}

export const UserDropdown = (): JSX.Element => {
  const { logout } = useAuth0();
  const navigate = useNavigate();
  const { theme } = useAppSelector((state) => state.app);

  const { user } = useAuth0();
  const { data, isLoading, isFetching } = useGetUserQuery(user?.sub as string);

  const styles: InlineStylesModel = {
    dropDown: {
      cursor: 'pointer'
    },
    menu: {
      alignItems: 'center',
      background: 'none',
      borderRight: 'none',
      display: 'flex',
      marginLeft: '8px'
    },
    menuIcon: {
      color: theme === 'dark' ? 'rgb(132, 133, 154)' : 'rgba(0, 0, 0, 0.65)',
      fontSize: '18px',
      marginLeft: '5px'
    }
  };

  const handleAboutPage = (): void => {
    navigate(`/about`);
  };

  const menu = (
    <Menu disabledOverflow={true} theme={theme === 'dark' ? 'dark' : 'light'}>
      <Menu.Item onClick={handleAboutPage} key={MenuKeys.about}>
        {MenuKeys.about}
      </Menu.Item>
      <Menu.Item key={MenuKeys.profile}>
        <a target="_blank" href={process.env.REACT_APP_PROFILE_URL} rel="noreferrer">
          {MenuKeys.profile}
        </a>
      </Menu.Item>
      <Menu.Item key={MenuKeys.logout} onClick={(): void => logout({})}>
        {MenuKeys.logout}
      </Menu.Item>
    </Menu>
  );

  return (
    <Dropdown overlay={menu}>
      <Avatar
        icon={isLoading || isFetching ? <Spin size="small" spinning></Spin> : <ProfileOutlined />}
        style={{
          marginLeft: 8,
          cursor: 'pointer',
          backgroundColor: theme === 'dark' ? '#1890ff' : '#f0f0f0',
          color: theme === 'dark' ? '#ffffff' : '#000000'
        }}
        src={data && data.user_metadata.profile_image_url ? data.user_metadata.profile_image_url : !isLoading || !isFetching ? user?.picture : undefined}
      />
    </Dropdown>
  );
};
